import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

/* Unified with QuickModals Shell: desktop centered (90vh), mobile bottom sheet. */
export default function Modal({ open, onClose, children, title, contentHeight }) {
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < 768);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  useEffect(() => {
    if (!open) return;
    const onEsc = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onEsc);
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onEsc); document.body.style.overflow = ''; };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 2000,
        background: 'rgba(12,10,9,0.55)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
        display: 'flex', alignItems: isMobile ? 'flex-end' : 'center', justifyContent: 'center',
        padding: isMobile ? 0 : 16, direction: 'rtl', overflowY: 'auto',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className={isMobile ? 'quick-sheet' : undefined}
        style={{
          background: 'var(--card)', color: 'var(--card-fg, var(--fg))',
          border: '1px solid var(--border)',
          borderRadius: isMobile ? '20px 20px 0 0' : 20,
          borderBottom: isMobile ? 'none' : undefined,
          width: isMobile ? '100%' : '100%',
          maxWidth: isMobile ? undefined : '620px',
          height: contentHeight || undefined,
          maxHeight: contentHeight || (isMobile ? 'min(90vh, calc(100dvh - 20px))' : '90vh'),
          overflowY: 'auto',
          boxShadow: '0 24px 60px rgba(0,0,0,0.25)', position: 'relative', padding: 22,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: title ? 14 : 0 }}>
          {title ? <h2 style={{ margin: 0, fontWeight: 800, fontSize: '1.05rem' }}>{title}</h2> : <span />}
          <button
            onClick={onClose}
            aria-label="بستن"
            style={{
              width: 34, height: 34, borderRadius: '50%',
              border: '1px solid var(--border)', background: 'var(--card)', color: 'var(--fg)',
              cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}
          >
            <X size={16} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}